import { PositionAssignmentFilterMeta } from '@src/main/modules/reports/ui/hooks/usePositionAssignmentFilters';
import { DataTableFilterMeta } from 'primereact/datatable';

export const usePositionAssignmentFilterHandler = (
  setFilters: (filters: PositionAssignmentFilterMeta) => void,
  refetchReports: () => void,
  setInvalidDateModalVisible: (visible: boolean) => void,
) => {
  const handleSetFilters = (newFilters: DataTableFilterMeta) => {
    const filtersTyped = newFilters as PositionAssignmentFilterMeta;

    const flightDateFilterMeta = filtersTyped.flightDate;

    if (flightDateFilterMeta && 'constraints' in flightDateFilterMeta) {
      const flightDateFilter = flightDateFilterMeta.constraints?.[0]?.value ?? null;

      if (
        Array.isArray(flightDateFilter) &&
        flightDateFilter[0] instanceof Date &&
        flightDateFilter[1] instanceof Date &&
        flightDateFilter[0] > flightDateFilter[1]
      ) {
        setInvalidDateModalVisible(true);
        return;
      }
    }

    setFilters(filtersTyped);
    refetchReports();
  };

  return { handleSetFilters };
};
